import React from "react";
import {BrowserRouter, Link, Route} from "react-router-dom";
import HelloWorld from "./components/a6/HelloWorld";
import Practice from "./components/a6/Practice";
import HomeScreen from "./components/a6/Build/HomeScreen/HomeScreen";
import ExploreScreen from "./components/a6/Build/ExploreScreen/ExploreScreen";
import './App.css';
import './vendors/bootstrap/bootstrap-5.1.1-dist/css/bootstrap.min.css';
import './vendors/bootstrap/bootstrap.min.css';
import './vendors/fontawesome-free-5.15.4-web/css/all.min.css';
import PracticeA7 from "./components/a7/Practice";
import Build from "./components/a7/Build";
import PracticeA8 from "./components/a8/Practice";
import BuildA8 from "./components/a8/Build";
import PracticeA9 from "./a9/Practice";
import HomeScreenA9 from "./a9/Build/HomeScreen";
import ProfileScreenA9 from "./a9/Build/Profiles";
import ExploreScreenA9 from "./a9/Build/ExploreScreen/ExploreScreen";
import EditProfileScreenA9 from "./a9/Build/EditProfiles";

function App() {
  return (
      <BrowserRouter>
        <div className="container">
          <Link to={"/a6/practice"}>A6 Practice | </Link>
          <Link to={"/a6/twitter"}>A6 Build | </Link>
          <Link to={"/a6/twitter"}>A6 Challenge</Link>
          <br/>
          <Link to={"/a7/practice"}>A7 Practice | </Link>
          <Link to={"/a7/twitter"}>A7 Build | </Link>
          <Link to={"/a7/twitter"}>A7 Challenge</Link>
          <br/>
          <Link to={"/a8/practice"}>A8 Practice | </Link>
          <Link to={"/a8/twitter"}>A8 Build | </Link>
          <Link to={"/a8/twitter"}>A8 Challenge</Link>
          <br/>
          <Link to={"/a9/practice"}>A9 Practice | </Link>
          <Link to={"/a9/twitter"}>A9 Build | </Link>
          <Link to={"/a9/twitter"}>A9 Challenge </Link>

          <Route path={["/a6/", "/a6/hello"]} exact={true}>
            <HelloWorld/>
          </Route>
          <Route path={"/a6/practice"} exact={true}>
            <Practice/>
          </Route>
          <Route path="/a6/twitter/home" component={HomeScreen}>
          </Route>
          <Route path="/a6/twitter/explore" component={ExploreScreen}>
          </Route>
          <Route path={["/a7/", "/a7/practice"]} exact={true}>
            <PracticeA7/>
          </Route>
          <Route path="/a7/twitter">
            <Build/>
          </Route>
          <Route path="/a7/Challenge">
            <Build/>
          </Route>
          <Route path={["/a8/", "/a8/practice"]} exact={true}>
            <PracticeA8/>
          </Route>
          <Route path="/a8/twitter">
            <BuildA8/>
          </Route>
          <Route path="/a8/challenge">
            <BuildA8/>
          </Route>
          <Route path="/a9/practice" exact={true}>
            <PracticeA9/>
          </Route>
          <Route path={["/a9/twitter", "/a9/twitter/home"]}
                 exact={true} component={HomeScreenA9}>
          </Route>
          <Route path="/a9/twitter/explore"
                 exact={true} component={ExploreScreenA9}>
          </Route>
          <Route path="/a9/twitter/profile"
                 exact={true} component={ProfileScreenA9}>
          </Route>
          <Route path="/a9/twitter/edit_profile"
                 exact={true} component={EditProfileScreenA9}>
          </Route>
        </div>
      </BrowserRouter>

  );
}

export default App;
